webpackJsonp([81,79],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _stringify = __webpack_require__(23);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vue = __webpack_require__(604);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(602);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(601);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vueCookies = __webpack_require__(431);
	
	var _vueCookies2 = _interopRequireDefault(_vueCookies);
	
	var _veeValidate = __webpack_require__(430);
	
	var _veeValidate2 = _interopRequireDefault(_veeValidate);
	
	var _vueFullCalendar = __webpack_require__(432);
	
	var _vueFullCalendar2 = _interopRequireDefault(_vueFullCalendar);
	
	var _vueWysiwyg = __webpack_require__(603);
	
	var _vueWysiwyg2 = _interopRequireDefault(_vueWysiwyg);
	
	var _jquery = __webpack_require__(131);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _routes = __webpack_require__(265);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _Header = __webpack_require__(436);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Sidebar = __webpack_require__(437);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Aside = __webpack_require__(434);
	
	var _Aside2 = _interopRequireDefault(_Aside);
	
	var _Footer = __webpack_require__(435);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(373);
	__webpack_require__(386);
	
	var config = {
	  errorBagName: 'errors',
	  fieldsBagName: 'fields',
	  delay: 0,
	  locale: 'en',
	  dictionary: null,
	  strict: true
	};
	
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueCookies2.default);
	_vue2.default.use(_veeValidate2.default, config);
	_vue2.default.use(_vueFullCalendar2.default);
	_vue2.default.use(_vueWysiwyg2.default);
	
	var router = new _vueRouter2.default({
	  routes: _routes2.default,
	  linkActiveClass: 'active',
	  history: true
	});
	
	router.beforeEach(function (to, from, next) {
	  var cookies = _vueCookies2.default;
	
	  if (cookies.isKey('op_session')) {
	    var dateNow = parseInt(new Date().getTime() / 1000);
	    if (dateNow >= cookies.get('op_session_last') || !cookies.isKey('op_session_last')) {
	      _vue2.default.http.post(("https://app.optimpractice.com/api") + '/user/refresh?token=' + cookies.get('op_session')).then(function (response) {
	        cookies.remove('op_session');
	        cookies.remove('op_session_content');
	        cookies.set('op_session', response.body.token, 2629746);
	        cookies.set('op_session_content', (0, _stringify2.default)(response.body), 2629746);
	
	        var date = new Date();
	        var nextSessionCheck = new Date(date.setMinutes(date.getMinutes() + 41760)).getTime() / 1000;
	        cookies.set('op_session_last', parseInt(nextSessionCheck), 2629746);
	      }, function (response) {
	        console.log(response);
	      });
	    }
	  }
	  if (to.path !== '/login' && to.path !== '/register' && to.name !== '/signup' && to.path !== '/forgot-password' && to.name !== '/reset-password' && to.name !== '/api/password/reset') {
	    if (cookies.get('op_session') === null) {
	      next({ path: '/login' });
	    } else {
	      next();
	    }
	  } else {
	    if (cookies.get('op_session') !== null) {
	      next({ path: '/dashboard' });
	    } else {
	      next();
	    }
	  }
	  if (!to.query.page) {
	    (0, _jquery2.default)('html, body').animate({ scrollTop: 0 }, 'slow');
	  }
	});
	
	new _vue2.default({
	  components: {
	    'app-header': _Header2.default,
	    'app-sidebar': _Sidebar2.default,
	    'app-aside': _Aside2.default,
	    'app-footer': _Footer2.default
	  },
	  router: router,
	  methods: {
	    isAdminPage: function isAdminPage(path, name) {
	      var publicComponents = ['/login', '/register', '/signup', '/forgot-password', '/reset-password', '/api/password/reset'];
	      return publicComponents.indexOf(path) >= 0 || publicComponents.indexOf(name) >= 0;
	    }
	  }
	}).$mount('#app');

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Dashboard = function Dashboard(resolve) {
	  return __webpack_require__.e/* require */(14, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(440)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var NotFound = function NotFound(resolve) {
	  return __webpack_require__.e/* require */(77, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(439)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	var Login = function Login(resolve) {
	  return __webpack_require__.e/* require */(61, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(441)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	};
	
	module.exports = [{ path: '/register', component: function component(resolve) {
	    return __webpack_require__.e/* require */(55, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(442)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  } }, { path: '/login', component: Login }, {
	  name: '/signup',
	  path: '/signup/:id',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(64, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(443)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, { path: '/', redirect: '/dashboard' }, { path: '/dashboard', component: Dashboard }, {
	  path: '/clients',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(75, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(451)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(18, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(450)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(8, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(448)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-client',
	    path: 'edit/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(6, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(449)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/deadlines',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(74, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(455)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(13, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(454)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(7, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(452)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-client',
	    path: 'edit/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(5, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(453)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/settings',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(70, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(484)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: 'profile',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(56, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(479)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(37, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(472)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add-region',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(45, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(480)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-region',
	    path: 'edit-region/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(44, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(481)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add-location-grade',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(49, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(475)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-location-grade',
	    path: 'edit-location-grade/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(48, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(476)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add-location-type',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(47, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(477)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-location-type',
	    path: 'edit-location-type/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(46, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(478)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add-deadline-category',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(58, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(473)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-deadline-category',
	    path: 'edit-deadline-category/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(57, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(474)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add-client-custom-field',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(51, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(470)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-client-custom-field',
	    path: 'edit-client-custom-field/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(50, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(471)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add-tags',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(43, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(482)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-tags',
	    path: 'edit-tags/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(42, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(483)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/fee-types',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(69, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(489)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(23, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(488)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'add-fee-type',
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(12, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(487)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'update-fee-type',
	    path: 'update/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(11, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(490)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/users',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(66, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(503)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(22, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(502)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(41, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(500)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'edit/:id',
	    name: 'edit-user',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(39, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(501)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/checklists',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(4, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(264)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(2, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(263)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(1, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(261)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'edit/:id',
	    name: 'edit-task',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(0, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(262)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/task-types',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(68, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(493)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(19, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(492)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'add-task-type',
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(26, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(491)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'update-task-type',
	    path: 'update/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(25, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(494)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/time-sheets',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(67, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(498)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(17, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(497)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'add-task',
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(16, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(495)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'update-task',
	    path: 'update/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(20, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(499)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'bulk-add',
	    path: 'bulk-add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(15, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(496)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/reports',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(72, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(463)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: 'user-tasks',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(31, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(464)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'completed-tasks',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(32, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(462)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'client-revenue',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(33, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(461)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'weekly-time',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(24, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(465)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/workflow',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(65, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(512)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(21, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(509)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'add',
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(10, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(504)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'workflow-tasks',
	    path: 'workflow-tasks/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(28, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(513)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'all-my-tasks',
	    path: 'all-my-tasks',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(35, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(505)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'continue-task',
	    path: 'continue-task/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(27, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(507)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'load-task',
	    path: 'load-task/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(38, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(510)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'start-task',
	    path: 'start-task/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(40, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(511)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'edit/:id',
	    name: 'edit-workflow',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(9, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(508)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'all-tasks',
	    path: 'all-tasks',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(34, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(506)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/announcements',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(76, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(446)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    name: 'all',
	    path: 'all',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(54, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(445)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'add-announcement',
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(30, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(444)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'update-announcement',
	    path: 'update/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(29, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(447)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/roles',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(71, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(469)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(62, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(468)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'add-role',
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(60, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(466)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    name: 'edit-role',
	    path: 'edit/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(59, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(467)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/tasks',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(4/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(264)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(2/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(263)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(1/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(261)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'edit/:id',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(0/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(262)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/departments',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(73, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(458)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  },
	  children: [{
	    path: '',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(36, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(457)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'add',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(53, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(456)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }, {
	    path: 'edit/:id',
	    name: 'update-department',
	    component: function component(resolve) {
	      return __webpack_require__.e/* require */(52, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(459)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	    }
	  }]
	}, {
	  path: '/403',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(78, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(438)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  path: '/forgot-password',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(63, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(460)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: '/reset-password',
	  path: '/reset-password/:id',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(3, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(260)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, {
	  name: '/api/password/reset',
	  path: '/api/password/reset/:id',
	  component: function component(resolve) {
	    return __webpack_require__.e/* require */(3/* duplicate */, function(__webpack_require__) { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(260)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this));
	  }
	}, { path: '*', component: NotFound }];

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(433);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	__webpack_require__(387);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    props: {
	        events: {
	            default: function _default() {
	                return [];
	            }
	        },
	
	        eventSources: {
	            default: function _default() {
	                return [];
	            }
	        },
	
	        editable: {
	            default: function _default() {
	                return true;
	            }
	        },
	
	        selectable: {
	            default: function _default() {
	                return true;
	            }
	        },
	
	        selectHelper: {
	            default: function _default() {
	                return true;
	            }
	        },
	
	        header: {
	            default: function _default() {
	                return {
	                    left: 'prev,next today',
	                    center: 'title',
	                    right: 'month,agendaWeek,agendaDay'
	                };
	            }
	        },
	
	        defaultView: {
	            default: function _default() {
	                return 'agendaWeek';
	            }
	        },
	
	        sync: {
	            default: function _default() {
	                return false;
	            }
	        },
	
	        config: {
	            type: Object,
	            default: function _default() {
	                return {};
	            }
	        }
	    },
	
	    computed: {
	        defaultConfig: function defaultConfig() {
	            var self = this;
	            return {
	                header: this.header,
	                defaultView: this.defaultView,
	                editable: this.editable,
	                selectable: this.selectable,
	                selectHelper: this.selectHelper,
	                aspectRatio: 2,
	                timeFormat: 'HH:mm',
	                events: this.events,
	                eventSources: this.eventSources,
	
	                eventRender: function eventRender(event, element, view) {
	                    if (this.sync) {
	                        self.events = cal.fullCalendar('clientEvents');
	                    }
	                    self.$emit('event-render', event, element, view);
	                },
	                eventDestroy: function eventDestroy(event) {
	                    if (this.sync) {
	                        self.events = cal.fullCalendar('clientEvents');
	                    }
	                },
	                eventClick: function eventClick(event, jsEvent, view) {
	                    self.$emit('event-selected', event, jsEvent, view);
	                },
	                eventDrop: function eventDrop(event) {
	                    self.$emit('event-drop', event);
	                },
	                eventResize: function eventResize(event) {
	                    self.$emit('event-resize', event);
	                },
	                dayClick: function dayClick(date, jsEvent, view) {
	                    self.$emit('day-click', date, jsEvent, view);
	                },
	                select: function select(start, end, jsEvent) {
	                    self.$emit('event-created', {
	                        start: start,
	                        end: end,
	                        allDay: !start.hasTime() && !end.hasTime()
	                    });
	                }
	            };
	        }
	    },
	
	    mounted: function mounted() {
	        var _this = this;
	
	        var cal = $(this.$el),
	            self = this;
	
	        this.$on('remove-event', function (event) {
	            $(_this.$el).fullCalendar('removeEvents', event.id);
	        });
	
	        this.$on('rerender-events', function () {
	            $(_this.$el).fullCalendar('rerenderEvents');
	        });
	
	        this.$on('refetch-events', function () {
	            $(_this.$el).fullCalendar('refetchEvents');
	        });
	
	        this.$on('render-event', function (event) {
	            $(_this.$el).fullCalendar('renderEvent', event);
	        });
	
	        this.$on('reload-events', function () {
	            $(_this.$el).fullCalendar('removeEvents');
	            $(_this.$el).fullCalendar('addEventSource', _this.events);
	        });
	
	        this.$on('rebuild-sources', function () {
	            $(_this.$el).fullCalendar('removeEvents');
	            _this.eventSources.map(function (event) {
	                $(_this.$el).fullCalendar('addEventSource', event);
	            });
	        });
	
	        cal.fullCalendar((0, _lodash2.default)(this.config, this.defaultConfig));
	    },
	
	
	    methods: {
	        fireMethod: function fireMethod() {
	            var _$;
	
	            (_$ = $(this.$el)).fullCalendar.apply(_$, arguments);
	        }
	    },
	
	    watch: {
	        events: {
	            deep: true,
	            handler: function handler(val) {
	                $(this.$el).fullCalendar('removeEvents');
	                $(this.$el).fullCalendar('addEventSource', this.events);
	            }
	        },
	        eventSources: {
	            deep: true,
	            handler: function handler(val) {
	                this.$emit('rebuild-sources');
	            }
	        }
	    },
	
	    beforeDestroy: function beforeDestroy() {
	        this.$off('remove-event');
	        this.$off('rerender-events');
	        this.$off('refetch-events');
	        this.$off('render-event');
	        this.$off('reload-events');
	        this.$off('rebuild-sources');
	    }
	};

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(64);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      logo: '',
	      company_name: 'The Company Name'
	    };
	  },
	  created: function created() {
	    var company = this.$cookies.isKey('op_session_content') ? JSON.parse(this.$cookies.get('op_session_content')) : [];
	    if ((0, _keys2.default)(company).length) {
	      this.company_name = company.company.name;
	      this.logo = company.company.logo;
	    }
	  },
	
	  methods: {
	    logout: function logout(event) {
	      this.$http.post(("https://app.optimpractice.com/api") + '/user/logout?token=' + this.$cookies.get('op_session')).then(function (response) {}, function (response) {});
	
	      this.$cookies.remove('op_session');
	      this.$cookies.remove('op_session_content');
	      this.$cookies.remove('op_session_last');
	      this.$router.go('/login');
	    }
	  }
	};

/***/ }),

/***/ 268:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  data: function data() {
	    return {
	      permissions: this.$cookies.isKey('op_session_content') ? JSON.parse(this.$cookies.get('op_session_content')).permissions : [],
	      transaction_paths: ['/time-tasks', '/workflow', '/workflow/all-my-tasks'],
	      reports_paths: ['/reports/user-tasks', '/reports/completed-tasks', '/reports/client-revenue', '/reports/weekly-time'],
	      settings_paths: ['/settings', '/users', '/roles', '/fee-types', '/task-types', '/checklists']
	    };
	  },
	  beforeCreate: function beforeCreate() {
	    this.permissions = this.$cookies.isKey('op_session_content') ? JSON.parse(this.$cookies.get('op_session_content')).permissions : [];
	  },
	
	  methods: {
	    isActiveMenuGroup: function isActiveMenuGroup() {
	      var menuitems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	      for (var i in menuitems) {
	        var pattern = new RegExp(menuitems[i]);
	        if (pattern.test(this.$route.path)) {
	          return true;
	        }
	      }
	    },
	    isActiveMenu: function isActiveMenu(path) {
	      var pattern = new RegExp(path);
	      if (path === '/workflow' || path === '/workflow/all-my-tasks') {
	        return path === this.$route.path;
	      } else {
	        return pattern.test(this.$route.path);
	      }
	    }
	  }
	};

/***/ }),

/***/ 373:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 385:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 386:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 145,
		"./af.js": 145,
		"./ar": 152,
		"./ar-dz": 146,
		"./ar-dz.js": 146,
		"./ar-kw": 147,
		"./ar-kw.js": 147,
		"./ar-ly": 148,
		"./ar-ly.js": 148,
		"./ar-ma": 149,
		"./ar-ma.js": 149,
		"./ar-sa": 150,
		"./ar-sa.js": 150,
		"./ar-tn": 151,
		"./ar-tn.js": 151,
		"./ar.js": 152,
		"./az": 153,
		"./az.js": 153,
		"./be": 154,
		"./be.js": 154,
		"./bg": 155,
		"./bg.js": 155,
		"./bn": 156,
		"./bn.js": 156,
		"./bo": 157,
		"./bo.js": 157,
		"./br": 158,
		"./br.js": 158,
		"./bs": 159,
		"./bs.js": 159,
		"./ca": 160,
		"./ca.js": 160,
		"./cs": 161,
		"./cs.js": 161,
		"./cv": 162,
		"./cv.js": 162,
		"./cy": 163,
		"./cy.js": 163,
		"./da": 164,
		"./da.js": 164,
		"./de": 167,
		"./de-at": 165,
		"./de-at.js": 165,
		"./de-ch": 166,
		"./de-ch.js": 166,
		"./de.js": 167,
		"./dv": 168,
		"./dv.js": 168,
		"./el": 169,
		"./el.js": 169,
		"./en-au": 170,
		"./en-au.js": 170,
		"./en-ca": 171,
		"./en-ca.js": 171,
		"./en-gb": 172,
		"./en-gb.js": 172,
		"./en-ie": 173,
		"./en-ie.js": 173,
		"./en-nz": 174,
		"./en-nz.js": 174,
		"./eo": 175,
		"./eo.js": 175,
		"./es": 177,
		"./es-do": 176,
		"./es-do.js": 176,
		"./es.js": 177,
		"./et": 178,
		"./et.js": 178,
		"./eu": 179,
		"./eu.js": 179,
		"./fa": 180,
		"./fa.js": 180,
		"./fi": 181,
		"./fi.js": 181,
		"./fo": 182,
		"./fo.js": 182,
		"./fr": 185,
		"./fr-ca": 183,
		"./fr-ca.js": 183,
		"./fr-ch": 184,
		"./fr-ch.js": 184,
		"./fr.js": 185,
		"./fy": 186,
		"./fy.js": 186,
		"./gd": 187,
		"./gd.js": 187,
		"./gl": 188,
		"./gl.js": 188,
		"./gom-latn": 189,
		"./gom-latn.js": 189,
		"./he": 190,
		"./he.js": 190,
		"./hi": 191,
		"./hi.js": 191,
		"./hr": 192,
		"./hr.js": 192,
		"./hu": 193,
		"./hu.js": 193,
		"./hy-am": 194,
		"./hy-am.js": 194,
		"./id": 195,
		"./id.js": 195,
		"./is": 196,
		"./is.js": 196,
		"./it": 197,
		"./it.js": 197,
		"./ja": 198,
		"./ja.js": 198,
		"./jv": 199,
		"./jv.js": 199,
		"./ka": 200,
		"./ka.js": 200,
		"./kk": 201,
		"./kk.js": 201,
		"./km": 202,
		"./km.js": 202,
		"./kn": 203,
		"./kn.js": 203,
		"./ko": 204,
		"./ko.js": 204,
		"./ky": 205,
		"./ky.js": 205,
		"./lb": 206,
		"./lb.js": 206,
		"./lo": 207,
		"./lo.js": 207,
		"./lt": 208,
		"./lt.js": 208,
		"./lv": 209,
		"./lv.js": 209,
		"./me": 210,
		"./me.js": 210,
		"./mi": 211,
		"./mi.js": 211,
		"./mk": 212,
		"./mk.js": 212,
		"./ml": 213,
		"./ml.js": 213,
		"./mr": 214,
		"./mr.js": 214,
		"./ms": 216,
		"./ms-my": 215,
		"./ms-my.js": 215,
		"./ms.js": 216,
		"./my": 217,
		"./my.js": 217,
		"./nb": 218,
		"./nb.js": 218,
		"./ne": 219,
		"./ne.js": 219,
		"./nl": 221,
		"./nl-be": 220,
		"./nl-be.js": 220,
		"./nl.js": 221,
		"./nn": 222,
		"./nn.js": 222,
		"./pa-in": 223,
		"./pa-in.js": 223,
		"./pl": 224,
		"./pl.js": 224,
		"./pt": 226,
		"./pt-br": 225,
		"./pt-br.js": 225,
		"./pt.js": 226,
		"./ro": 227,
		"./ro.js": 227,
		"./ru": 228,
		"./ru.js": 228,
		"./sd": 229,
		"./sd.js": 229,
		"./se": 230,
		"./se.js": 230,
		"./si": 231,
		"./si.js": 231,
		"./sk": 232,
		"./sk.js": 232,
		"./sl": 233,
		"./sl.js": 233,
		"./sq": 234,
		"./sq.js": 234,
		"./sr": 236,
		"./sr-cyrl": 235,
		"./sr-cyrl.js": 235,
		"./sr.js": 236,
		"./ss": 237,
		"./ss.js": 237,
		"./sv": 238,
		"./sv.js": 238,
		"./sw": 239,
		"./sw.js": 239,
		"./ta": 240,
		"./ta.js": 240,
		"./te": 241,
		"./te.js": 241,
		"./tet": 242,
		"./tet.js": 242,
		"./th": 243,
		"./th.js": 243,
		"./tl-ph": 244,
		"./tl-ph.js": 244,
		"./tlh": 245,
		"./tlh.js": 245,
		"./tr": 246,
		"./tr.js": 246,
		"./tzl": 247,
		"./tzl.js": 247,
		"./tzm": 249,
		"./tzm-latn": 248,
		"./tzm-latn.js": 248,
		"./tzm.js": 249,
		"./uk": 250,
		"./uk.js": 250,
		"./ur": 251,
		"./ur.js": 251,
		"./uz": 253,
		"./uz-latn": 252,
		"./uz-latn.js": 252,
		"./uz.js": 253,
		"./vi": 254,
		"./vi.js": 254,
		"./x-pseudo": 255,
		"./x-pseudo.js": 255,
		"./yo": 256,
		"./yo.js": 256,
		"./zh-cn": 257,
		"./zh-cn.js": 257,
		"./zh-hk": 258,
		"./zh-hk.js": 258,
		"./zh-tw": 259,
		"./zh-tw.js": 259
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 427;


/***/ }),

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(542),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(579),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(267),
	  /* template */
	  __webpack_require__(551),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(385)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(268),
	  /* template */
	  __webpack_require__(587),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 514:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(266),
	  /* template */
	  __webpack_require__(560),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 542:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.$parent.isAdminPage(_vm.$route.path)) ? _c('aside', {
	    staticClass: "aside-menu"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1)]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticClass: "nav nav-tabs",
	    attrs: {
	      "role": "tablist"
	    }
	  }, [_c('li', {
	    staticClass: "nav-item"
	  }, [_c('a', {
	    staticClass: "nav-link active",
	    attrs: {
	      "data-toggle": "tab",
	      "href": "#timeline",
	      "role": "tab"
	    }
	  }, [_c('i', {
	    staticClass: "icon-list"
	  })])]), _vm._v(" "), _c('li', {
	    staticClass: "nav-item"
	  }, [_c('a', {
	    staticClass: "nav-link",
	    attrs: {
	      "data-toggle": "tab",
	      "href": "#messages",
	      "role": "tab"
	    }
	  }, [_c('i', {
	    staticClass: "icon-speech"
	  })])]), _vm._v(" "), _c('li', {
	    staticClass: "nav-item"
	  }, [_c('a', {
	    staticClass: "nav-link",
	    attrs: {
	      "data-toggle": "tab",
	      "href": "#settings",
	      "role": "tab"
	    }
	  }, [_c('i', {
	    staticClass: "icon-settings"
	  })])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tab-content"
	  }, [_c('div', {
	    staticClass: "tab-pane active",
	    attrs: {
	      "id": "timeline",
	      "role": "tabpanel"
	    }
	  }, [_c('div', {
	    staticClass: "callout m-0 py-h text-muted text-xs-center bg-faded text-uppercase"
	  }, [_c('small', [_c('b', [_vm._v("Today")])])]), _vm._v(" "), _c('hr', {
	    staticClass: "transparent mx-1 my-0"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "callout callout-warning m-0 py-1"
	  }, [_c('div', {
	    staticClass: "avatar float-xs-right"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/7.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  })]), _vm._v(" "), _c('div', [_vm._v("Meeting with\n                    "), _c('strong', [_vm._v("Lucas")])]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted mr-1"
	  }, [_c('i', {
	    staticClass: "icon-calendar"
	  }), _vm._v("  1 - 3pm")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_c('i', {
	    staticClass: "icon-location-pin"
	  }), _vm._v("  Palo Alto, CA")])]), _vm._v(" "), _c('hr', {
	    staticClass: "mx-1 my-0"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "callout callout-info m-0 py-1"
	  }, [_c('div', {
	    staticClass: "avatar float-xs-right"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/4.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  })]), _vm._v(" "), _c('div', [_vm._v("Skype with\n                    "), _c('strong', [_vm._v("Megan")])]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted mr-1"
	  }, [_c('i', {
	    staticClass: "icon-calendar"
	  }), _vm._v("  4 - 5pm")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_c('i', {
	    staticClass: "icon-social-skype"
	  }), _vm._v("  On-line")])]), _vm._v(" "), _c('hr', {
	    staticClass: "transparent mx-1 my-0"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "callout m-0 py-h text-muted text-xs-center bg-faded text-uppercase"
	  }, [_c('small', [_c('b', [_vm._v("Tomorrow")])])]), _vm._v(" "), _c('hr', {
	    staticClass: "transparent mx-1 my-0"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "callout callout-danger m-0 py-1"
	  }, [_c('div', [_vm._v("New UI Project -\n                    "), _c('strong', [_vm._v("deadline")])]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted mr-1"
	  }, [_c('i', {
	    staticClass: "icon-calendar"
	  }), _vm._v("  10 - 11pm")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_c('i', {
	    staticClass: "icon-home"
	  }), _vm._v("  creativeLabs HQ")]), _vm._v(" "), _c('div', {
	    staticClass: "avatars-stack mt-h"
	  }, [_c('div', {
	    staticClass: "avatar avatar-xs"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/2.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "avatar avatar-xs"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/3.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "avatar avatar-xs"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/4.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "avatar avatar-xs"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/5.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "avatar avatar-xs"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/6.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  })])])]), _vm._v(" "), _c('hr', {
	    staticClass: "mx-1 my-0"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "callout callout-success m-0 py-1"
	  }, [_c('div', [_c('strong', [_vm._v("#10 Startups.Garden")]), _vm._v("Meetup")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted mr-1"
	  }, [_c('i', {
	    staticClass: "icon-calendar"
	  }), _vm._v("  1 - 3pm")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_c('i', {
	    staticClass: "icon-location-pin"
	  }), _vm._v("  Palo Alto, CA")])]), _vm._v(" "), _c('hr', {
	    staticClass: "mx-1 my-0"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "callout callout-primary m-0 py-1"
	  }, [_c('div', [_c('strong', [_vm._v("Team meeting")])]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted mr-1"
	  }, [_c('i', {
	    staticClass: "icon-calendar"
	  }), _vm._v("  4 - 6pm")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_c('i', {
	    staticClass: "icon-home"
	  }), _vm._v("  creativeLabs HQ")]), _vm._v(" "), _c('div', {
	    staticClass: "avatars-stack mt-h"
	  }, [_c('div', {
	    staticClass: "avatar avatar-xs"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/2.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "avatar avatar-xs"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/3.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "avatar avatar-xs"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/4.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "avatar avatar-xs"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/5.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "avatar avatar-xs"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/6.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "avatar avatar-xs"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/7.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "avatar avatar-xs"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/8.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  })])])]), _vm._v(" "), _c('hr', {
	    staticClass: "mx-1 my-0"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tab-pane p-1",
	    attrs: {
	      "id": "messages",
	      "role": "tabpanel"
	    }
	  }, [_c('div', {
	    staticClass: "message"
	  }, [_c('div', {
	    staticClass: "py-1 pb-3 mr-1 float-xs-left"
	  }, [_c('div', {
	    staticClass: "avatar"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/7.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "avatar-status tag-success"
	  })])]), _vm._v(" "), _c('div', [_c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("Lukasz Holeczek")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted float-xs-right mt-q"
	  }, [_vm._v("1:52 PM")])]), _vm._v(" "), _c('div', {
	    staticClass: "text-truncate font-weight-bold"
	  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "message"
	  }, [_c('div', {
	    staticClass: "py-1 pb-3 mr-1 float-xs-left"
	  }, [_c('div', {
	    staticClass: "avatar"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/7.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "avatar-status tag-success"
	  })])]), _vm._v(" "), _c('div', [_c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("Lukasz Holeczek")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted float-xs-right mt-q"
	  }, [_vm._v("1:52 PM")])]), _vm._v(" "), _c('div', {
	    staticClass: "text-truncate font-weight-bold"
	  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "message"
	  }, [_c('div', {
	    staticClass: "py-1 pb-3 mr-1 float-xs-left"
	  }, [_c('div', {
	    staticClass: "avatar"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/7.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "avatar-status tag-success"
	  })])]), _vm._v(" "), _c('div', [_c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("Lukasz Holeczek")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted float-xs-right mt-q"
	  }, [_vm._v("1:52 PM")])]), _vm._v(" "), _c('div', {
	    staticClass: "text-truncate font-weight-bold"
	  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "message"
	  }, [_c('div', {
	    staticClass: "py-1 pb-3 mr-1 float-xs-left"
	  }, [_c('div', {
	    staticClass: "avatar"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/7.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "avatar-status tag-success"
	  })])]), _vm._v(" "), _c('div', [_c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("Lukasz Holeczek")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted float-xs-right mt-q"
	  }, [_vm._v("1:52 PM")])]), _vm._v(" "), _c('div', {
	    staticClass: "text-truncate font-weight-bold"
	  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
	    staticClass: "message"
	  }, [_c('div', {
	    staticClass: "py-1 pb-3 mr-1 float-xs-left"
	  }, [_c('div', {
	    staticClass: "avatar"
	  }, [_c('img', {
	    staticClass: "img-avatar",
	    attrs: {
	      "src": "/static/img/avatars/7.jpg",
	      "alt": "admin@bootstrapmaster.com"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "avatar-status tag-success"
	  })])]), _vm._v(" "), _c('div', [_c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("Lukasz Holeczek")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted float-xs-right mt-q"
	  }, [_vm._v("1:52 PM")])]), _vm._v(" "), _c('div', {
	    staticClass: "text-truncate font-weight-bold"
	  }, [_vm._v("Lorem ipsum dolor sit amet")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt...")])])]), _vm._v(" "), _c('div', {
	    staticClass: "tab-pane p-1",
	    attrs: {
	      "id": "settings",
	      "role": "tabpanel"
	    }
	  }, [_c('h6', [_vm._v("Settings")]), _vm._v(" "), _c('div', {
	    staticClass: "aside-options"
	  }, [_c('div', {
	    staticClass: "clearfix mt-2"
	  }, [_c('small', [_c('b', [_vm._v("Option 1")])]), _vm._v(" "), _c('label', {
	    staticClass: "switch switch-text switch-pill switch-success switch-sm float-xs-right"
	  }, [_c('input', {
	    staticClass: "switch-input",
	    attrs: {
	      "type": "checkbox",
	      "checked": ""
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "switch-label",
	    attrs: {
	      "data-on": "On",
	      "data-off": "Off"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "switch-handle"
	  })])]), _vm._v(" "), _c('div', [_c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.")])])]), _vm._v(" "), _c('div', {
	    staticClass: "aside-options"
	  }, [_c('div', {
	    staticClass: "clearfix mt-1"
	  }, [_c('small', [_c('b', [_vm._v("Option 2")])]), _vm._v(" "), _c('label', {
	    staticClass: "switch switch-text switch-pill switch-success switch-sm float-xs-right"
	  }, [_c('input', {
	    staticClass: "switch-input",
	    attrs: {
	      "type": "checkbox"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "switch-label",
	    attrs: {
	      "data-on": "On",
	      "data-off": "Off"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "switch-handle"
	  })])]), _vm._v(" "), _c('div', [_c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.")])])]), _vm._v(" "), _c('div', {
	    staticClass: "aside-options"
	  }, [_c('div', {
	    staticClass: "clearfix mt-1"
	  }, [_c('small', [_c('b', [_vm._v("Option 3")])]), _vm._v(" "), _c('label', {
	    staticClass: "switch switch-text switch-pill switch-success switch-sm float-xs-right"
	  }, [_c('input', {
	    staticClass: "switch-input",
	    attrs: {
	      "type": "checkbox"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "switch-label",
	    attrs: {
	      "data-on": "On",
	      "data-off": "Off"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "switch-handle"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "aside-options"
	  }, [_c('div', {
	    staticClass: "clearfix mt-1"
	  }, [_c('small', [_c('b', [_vm._v("Option 4")])]), _vm._v(" "), _c('label', {
	    staticClass: "switch switch-text switch-pill switch-success switch-sm float-xs-right"
	  }, [_c('input', {
	    staticClass: "switch-input",
	    attrs: {
	      "type": "checkbox",
	      "checked": ""
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "switch-label",
	    attrs: {
	      "data-on": "On",
	      "data-off": "Off"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "switch-handle"
	  })])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h6', [_vm._v("System Utilization")]), _vm._v(" "), _c('div', {
	    staticClass: "text-uppercase mb-q mt-2"
	  }, [_c('small', [_c('b', [_vm._v("CPU Usage")])])]), _vm._v(" "), _c('progress', {
	    staticClass: "progress progress-xs progress-info m-0",
	    attrs: {
	      "value": "25",
	      "max": "100"
	    }
	  }, [_vm._v("25%")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("348 Processes. 1/4 Cores.")]), _vm._v(" "), _c('div', {
	    staticClass: "text-uppercase mb-q mt-h"
	  }, [_c('small', [_c('b', [_vm._v("Memory Usage")])])]), _vm._v(" "), _c('progress', {
	    staticClass: "progress progress-xs progress-warning m-0",
	    attrs: {
	      "value": "70",
	      "max": "100"
	    }
	  }, [_vm._v("70%")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("11444GB/16384MB")]), _vm._v(" "), _c('div', {
	    staticClass: "text-uppercase mb-q mt-h"
	  }, [_c('small', [_c('b', [_vm._v("SSD 1 Usage")])])]), _vm._v(" "), _c('progress', {
	    staticClass: "progress progress-xs progress-danger m-0",
	    attrs: {
	      "value": "95",
	      "max": "100"
	    }
	  }, [_vm._v("95%")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("243GB/256GB")]), _vm._v(" "), _c('div', {
	    staticClass: "text-uppercase mb-q mt-h"
	  }, [_c('small', [_c('b', [_vm._v("SSD 2 Usage")])])]), _vm._v(" "), _c('progress', {
	    staticClass: "progress progress-xs progress-success m-0",
	    attrs: {
	      "value": "10",
	      "max": "100"
	    }
	  }, [_vm._v("10%")]), _vm._v(" "), _c('small', {
	    staticClass: "text-muted"
	  }, [_vm._v("25GB/256GB")])])])
	}]}

/***/ }),

/***/ 551:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.$parent.isAdminPage(_vm.$route.path, _vm.$route.name)) ? _c('header', {
	    staticClass: "navbar"
	  }, [_c('div', {
	    staticClass: "container-fluid"
	  }, [_c('button', {
	    staticClass: "navbar-toggler mobile-toggler hidden-lg-up",
	    attrs: {
	      "type": "button"
	    }
	  }, [_vm._v("☰")]), _vm._v(" "), _c('router-link', {
	    staticClass: "navbar-brand",
	    staticStyle: {
	      "padding": "0",
	      "text-align": "center",
	      "background-image": "none"
	    },
	    attrs: {
	      "to": "/dashboard",
	      "exact": ""
	    }
	  }, [(!_vm.logo) ? _c('span', [_vm._v(_vm._s(_vm.company_name))]) : _c('img', {
	    staticClass: "logo",
	    attrs: {
	      "src": _vm.logo
	    }
	  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('ul', {
	    staticClass: "nav navbar-nav float-xs-right"
	  }, [_c('li', {
	    staticClass: "nav-item dropdown"
	  }, [_vm._m(1), _vm._v(" "), _c('div', {
	    staticClass: "dropdown-menu dropdown-menu-right"
	  }, [_c('router-link', {
	    staticClass: "dropdown-item",
	    attrs: {
	      "to": {
	        path: '/settings/profile',
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-user"
	  }), _vm._v(" Profile\n                    ")]), _vm._v(" "), _c('router-link', {
	    staticClass: "dropdown-item",
	    attrs: {
	      "to": {
	        path: '/settings',
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-wrench"
	  }), _vm._v(" Settings\n                    ")]), _vm._v(" "), _c('a', {
	    staticClass: "dropdown-item",
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.logout($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-lock"
	  }), _vm._v(" Logout")])], 1)])])], 1)]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticClass: "nav navbar-nav hidden-md-down float-xs-left"
	  }, [_c('li', {
	    staticClass: "nav-item"
	  }, [_c('a', {
	    staticClass: "nav-link navbar-toggler layout-toggler",
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("☰")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "nav-link avatar",
	    attrs: {
	      "data-toggle": "dropdown",
	      "href": "#",
	      "role": "button",
	      "aria-haspopup": "true",
	      "aria-expanded": "false"
	    }
	  }, [_c('i', {
	    staticClass: "icon-user icons font-2xl",
	    staticStyle: {
	      "color": "#36a9e1"
	    }
	  })])
	}]}

/***/ }),

/***/ 560:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "calendar",
	    attrs: {
	      "id": "calendar"
	    }
	  })
	},staticRenderFns: []}

/***/ }),

/***/ 579:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.$parent.isAdminPage(_vm.$route.path)) ? _c('footer', {
	    staticClass: "footer"
	  }) : _vm._e()
	},staticRenderFns: []}

/***/ }),

/***/ 587:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.$parent.isAdminPage(_vm.$route.path, _vm.$route.name)) ? _c('div', {
	    staticClass: "sidebar"
	  }, [_c('nav', {
	    staticClass: "sidebar-nav"
	  }, [_c('ul', {
	    staticClass: "nav"
	  }, [_c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(dashboard)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": "/dashboard",
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "icon-speedometer"
	  }), _vm._v(" Dashboard\n                  ")])], 1), _vm._v(" "), (_vm.permissions.indexOf('timetracking_task_read') >= 0) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(time-sheets)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/time-sheets',
	        query: {
	          page: 1
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-clock-o"
	  }), _vm._v(" Time Sheet\n                  ")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissions.indexOf('workflow_all_my_tasks') >= 0) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('/workflow/all-my-tasks')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/workflow/all-my-tasks',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-tasks"
	  }), _vm._v(" My Tasks\n                  ")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissions.indexOf('workflow_all_workflow_tasks') >= 0) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('/workflow/all-tasks')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/workflow/all-tasks',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-tasks"
	  }), _vm._v(" All Tasks\n                  ")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissions.indexOf('client_read') >= 0) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(clients)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/clients',
	        query: {
	          page: 1
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-users"
	  }), _vm._v(" Clients\n                  ")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissions.indexOf('see_all_deadlines') >= 0) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(deadlines)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/deadlines',
	        query: {
	          page: 1
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-clock-o"
	  }), _vm._v(" Deadlines\n                  ")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissions.indexOf('reports_read') >= 0) ? _c('li', {
	    staticClass: "nav-item nav-dropdown",
	    class: {
	      'open': _vm.isActiveMenuGroup(_vm.reports_paths)
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('ul', {
	    staticClass: "nav-dropdown-items"
	  }, [_c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(reports/user-tasks)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/reports/user-tasks',
	        query: {
	          page: 1
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-tasks"
	  }), _vm._v(" User Tasks\n                          ")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(reports/completed-tasks)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/reports/completed-tasks',
	        query: {
	          page: 1
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-calendar-check-o"
	  }), _vm._v(" Completed Tasks\n                          ")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(reports/client-revenue)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/reports/client-revenue',
	        query: {
	          page: 1
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-dollar"
	  }), _vm._v(" Client Revenue\n                          ")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(reports/weekly-time)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/reports/weekly-time',
	        query: {
	          page: 1
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-clock-o"
	  }), _vm._v(" Weekly Time\n                          ")])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.permissions.indexOf('company_management') >= 0) ? _c('li', {
	    staticClass: "nav-item nav-dropdown",
	    class: {
	      'open': _vm.isActiveMenuGroup(_vm.settings_paths)
	    }
	  }, [_vm._m(1), _vm._v(" "), _c('ul', {
	    staticClass: "nav-dropdown-items"
	  }, [_c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(settings)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/settings'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-cog"
	  }), _vm._v(" Settings\n                      ")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(users)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/users'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-users"
	  }), _vm._v(" Manage Users\n                      ")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(roles)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/roles'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-building"
	  }), _vm._v(" Manage Roles\n                      ")])], 1), _vm._v(" "), (_vm.permissions.indexOf('timetracking_cost_type_read') >= 0) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(fee-types)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/fee-types',
	        query: {
	          page: 1
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-dollar"
	  }), _vm._v(" Fee Type\n                      ")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissions.indexOf('timetracking_task_type_read') >= 0) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(task-types)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/task-types',
	        query: {
	          page: 1
	        }
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-align-justify"
	  }), _vm._v(" Task Type\n                      ")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissions.indexOf('workflow_checklist_index') >= 0) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('(checklists)')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/checklists',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-square-o"
	  }), _vm._v(" Checklists\n                      ")])], 1) : _vm._e(), _vm._v(" "), (_vm.permissions.indexOf('workflow_index') >= 0) ? _c('li', {
	    staticClass: "nav-item",
	    class: {
	      'active-menu': _vm.isActiveMenu('/workflow')
	    }
	  }, [_c('router-link', {
	    staticClass: "nav-link",
	    attrs: {
	      "to": {
	        path: '/workflow',
	        query: {
	          page: 1
	        }
	      },
	      "exact": ""
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-recycle"
	  }), _vm._v(" Workflow templates\n                      ")])], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "nav-link nav-dropdown-toggle",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-area-chart"
	  }), _vm._v("Reports")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "nav-link nav-dropdown-toggle",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "icon-wrench"
	  }), _vm._v("Settings")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "nav-item"
	  }, [_c('a', {
	    staticClass: "nav-link",
	    attrs: {
	      "href": "http://optimpractice.com/support",
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-support"
	  }), _vm._v(" Support\n                  ")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', {
	    staticClass: "nav-item"
	  }, [_c('a', {
	    staticClass: "nav-link",
	    attrs: {
	      "href": "http://optimpractice.com/getting-started",
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-rocket"
	  }), _vm._v(" Getting Started\n                  ")])])
	}]}

/***/ }),

/***/ 606:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.8c24be16048449a4b265.js